import { Dialog, Loader } from '@pocketlaw/tetris';
export function LoadingDialog() {
    return (<Dialog>
      <Loader size={16}/>
    </Dialog>);
}
